"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BadgeContainer = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _styledComponentsModifiers = require("styled-components-modifiers");

var _designTokens = require("@decisiv/design-tokens");

var _color = _interopRequireDefault(require("../../modifiers/color"));

var _constants = require("./constants");

var _commonUIColors = require("../../utils/commonUIColors");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    keys.push.apply(keys, Object.getOwnPropertySymbols(object));
  }

  if (enumerableOnly) keys = keys.filter(function (sym) {
    return Object.getOwnPropertyDescriptor(object, sym).enumerable;
  });
  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var FG_COLOR = {
  pastel: 'dark'
};
var PALETTE_MAPPER = {
  pastel: 'light',
  bright: 'medium'
};

var colorModifiers = function colorModifiers(props) {
  var _props$palette = props.palette,
      palette = _props$palette === void 0 ? 'bright' : _props$palette,
      color = props.color;

  if (color && color in _commonUIColors.commonUIColors) {
    var baseColor = _commonUIColors.commonUIThreeShadeColors[color];
    var fgColor = palette === 'bright' ? _designTokens.color.base.snowWhite : baseColor[FG_COLOR[palette]];
    var bgColor = baseColor[PALETTE_MAPPER[palette]];
    var colorPalette = palette === 'bright' ? bgColor : _objectSpread({}, bgColor, {
      fg: fgColor
    });
    return (0, _styledComponents.css)(["", ""], (0, _color.default)(colorPalette));
  }

  return null;
};

var getSizeStyles = function getSizeStyles(key) {
  return (0, _styledComponents.css)(_constants.sizeStyles[key] || '');
};

var sizeModifiers = (0, _styledComponentsModifiers.applyStyleModifiers)({
  small: function small(_ref) {
    var v = _ref.variant;
    return getSizeStyles("small.".concat(v));
  },
  medium: function medium(_ref2) {
    var v = _ref2.variant;
    return getSizeStyles("medium.".concat(v));
  },
  large: function large(_ref3) {
    var v = _ref3.variant;
    return getSizeStyles("large.".concat(v));
  }
}, 'size');
var variantModifiers = (0, _styledComponentsModifiers.applyStyleModifiers)({
  round: function round() {
    return (0, _styledComponents.css)({
      borderRadius: '50%'
    });
  },
  square: function square() {
    return (0, _styledComponents.css)({
      borderRadius: '2px'
    });
  }
}, 'variant'); // The default coloring is explicitly set instead of relying on the
// `visualInterest.licoriceMousse.medium` colors. The "default" badge is
// intended to be used in “empty” and/or “no results” messages, the snowWhite
// fg color and lower contrast help convey “emptiness”.
// eslint-disable-next-line import/prefer-default-export

var BadgeContainer = _styledComponents.default.div.withConfig({
  displayName: "styles__BadgeContainer",
  componentId: "sc-1lruwqa-0"
})(["align-items:center;display:inline-flex;justify-content:center;", ";", ";", ";"], colorModifiers, sizeModifiers, variantModifiers);

exports.BadgeContainer = BadgeContainer;